module.exports = __webpack_public_path__ + "static/media/meetup.89efb506.png";